//媒体发布
import media from '../view/systemManage/media-releases/media-releases.vue'
import broadcastAnnouncement from '../view/systemManage/media-releases/broadcast/broadcast-announcement.vue'
import systemAnnouncement from '../view/systemManage/media-releases/broadcast/system-announcement.vue'
//雪亮发布
import xlRelease from '../view/systemManage/media-releases/xl-release/xl-release.vue'


const mediaRelease = {
    path: '/media-release',
    component: media,
    redirect: '/media-release/broadcast-announcement',
    children: [
        {
            path: '/media-release/broadcast-announcement',
            name: 'broadcastAnnouncement',
            component: broadcastAnnouncement,
            meta: {
                title: '应急广播'
            }
        }, {
            path: '/media-release/system-announcement',
            name: 'systemAnnouncement',
            component: systemAnnouncement,
            meta: {
                title: '系统公告'
            }
        }, {
            path: '/media-release/xl-release',
            name: 'xlRelease',
            component: xlRelease,
            meta: {
                title: '雪亮发布'
            }
        },
    ]
}

export default mediaRelease
